import { Components } from '@mui/material/styles/components';
import { ControllerFont } from '../../fonts';
import theme from '../../provider/controllerBaseTheme';

export const AlertComponent: Components = {
  MuiAlert: {
    defaultProps: {
      variant: 'filled',
    },
    styleOverrides: {
      root: {
        color: theme.palette.common.white,
        display: 'inline-flex',
        ...ControllerFont.Body400R,
        padding: theme.spacing(1, 2, 1, 1),

        '& .MuiAlert-action': {
          alignSelf: 'center',
          padding: 0,
        },

        '& .MuiAlert-icon': {
          alignSelf: 'center',
          padding: 0,
        },

        '& .MuiAlert-message': {
          alignSelf: 'center',
          padding: 0,
          width: '100%',
        },

        '&.MuiAlert-standard': {
          color: theme.palette.common.black,
        },
        '&.MuiAlert-standardError': {
          backgroundColor: theme.palette.error.light,
          '& .MuiAlert-icon': {
            color: theme.palette.error.main,
          },
        },
        '&.MuiAlert-standardWarning': {
          backgroundColor: theme.palette.warning.light,
          '& .MuiAlert-icon': {
            color: theme.palette.warning.main,
          },
        },
        '&.MuiAlert-standardInfo': {
          backgroundColor: theme.palette.info.light,
          '& .MuiAlert-icon': {
            color: theme.palette.info.main,
          },
        },
        '&.MuiAlert-standardSuccess': {
          backgroundColor: theme.palette.success.light,
          '& .MuiAlert-icon': {
            color: theme.palette.success.main,
          },
        },

        '&.MuiAlert-outlined': {
          color: theme.palette.common.black,
        },
        '&.MuiAlert-outlinedError': {
          backgroundColor: theme.palette.error.light,
          borderColor: theme.palette.error.main,
          '& .MuiAlert-icon': {
            color: theme.palette.error.main,
          },
        },
        '&.MuiAlert-outlinedWarning': {
          backgroundColor: theme.palette.warning.light,
          borderColor: theme.palette.warning.main,
          '& .MuiAlert-icon': {
            color: theme.palette.warning.main,
          },
        },
        '&.MuiAlert-outlinedInfo': {
          backgroundColor: theme.palette.info.light,
          borderColor: theme.palette.info.main,
          '& .MuiAlert-icon': {
            color: theme.palette.info.main,
          },
        },
        '&.MuiAlert-outlinedSuccess': {
          backgroundColor: theme.palette.success.light,
          borderColor: theme.palette.success.main,
          '& .MuiAlert-icon': {
            color: theme.palette.success.main,
          },
        },
      },
    },
  },
  MuiAlertTitle: {
    styleOverrides: {
      root: {
        ...ControllerFont.Heading300B,
        margin: 0,
      },
    },
  },
};
